module.exports = __webpack_public_path__ + "static/media/betting_shortcut.7b2bce81.png";